import manageAssociatesService from "../pages/associates/services/ManageAssociatesService"
import userSettingsService from "../pages/associates/services/UserSettingsService"
import { TicketType } from "../pages/vdo-ticket/services/TicketType"

const useAutoAssignModal = (associate, impersonatingId) => {

    /**
     * Loads a list of user's district offices, as well as a list of assigned offices for this associate 
     * @param {number} id of the associate to load offices for
     */
    const loadOfficeLists = async (associateId) => {
        // find available and assigned offices
        let [myOfficesResponse, assignedOfficesResponse] = await Promise.allSettled([
            manageAssociatesService.getAllMyOffices(impersonatingId),
            manageAssociatesService.getAssociateOffices(associate.id)])

        if (myOfficesResponse.status === 'fulfilled' && assignedOfficesResponse.status === 'fulfilled') {
            // success! determine which offices belong where
            let allOffices = myOfficesResponse.value || []
            let assignedIds = (assignedOfficesResponse.value || {}).activeOfficeIds || []

            return {
                homeOffice: allOffices.find(o => `${o.id}` === `${associate.officeId}`),
                allOffices: allOffices,
                assignedOffices: allOffices.filter(o => assignedIds.includes(o.id)),
                availableOffices: allOffices.filter(o => !assignedIds.includes(o.id) && o.id !== associate.officeId)
            }
        } else {
            if (myOfficesResponse.status === 'rejected') {
                throw myOfficesResponse.reason
            }
            if (assignedOfficesResponse.status === 'rejected') {
                throw assignedOfficesResponse.reason
            }
        }
    }

    /**
     * Load the user settings to determine assignability and return a list of types
     */
    const buildProductLists = async () => {
        const proProducts = []
        const allProducts = localStorage.getItem('autoassignable_products')?.split(",") || [];

        if (associate?.isRteAssignable) {
            proProducts.push(TicketType.VDO)
        }

        if (associate?.isVirAssignable) {
            proProducts.push(TicketType.VIR)
        }

        return {
            availableProducts: allProducts.filter(o => !proProducts.includes(o)),
            assignedProducts: proProducts
        }
    }

    /**
     * Saves user settings for autoassignment based on a list of products
     * @param {any} assignedOfficeIds array of office ids as integers
     * @param {any} assignedProducts array of products as strings
     */
    const saveAutoAssignability = async (assignedOfficeIds, assignedProducts) => {
        let isRteAssignable = assignedProducts.includes(TicketType.VDO)
        let isVirAssignable = assignedProducts.includes(TicketType.VIR)

        let [officesResponse, settingsResponse] = await Promise.allSettled([
            manageAssociatesService.saveAssociateOffices(associate.id, assignedOfficeIds),
            userSettingsService.saveUserSettings(associate.id, isRteAssignable, isVirAssignable)])

        if (officesResponse.status === 'fulfilled' && settingsResponse.status === 'fulfilled') {
            return {
                officesResponse: officesResponse.value, // updated offices list
                productsResponse: settingsResponse.value // updated user settings
            }
        } else {
            if (officesResponse.status === 'rejected') {
                throw officesResponse.reason
            }
            if (settingsResponse.status === 'rejected') {
                throw settingsResponse.reason
            }
        }
    }
    
    return {
        loadOfficeLists,
        buildProductLists,
        saveAutoAssignability
    }
}

export default useAutoAssignModal